export type CustomerFilterMode = 'visibility' | 'staff' | 'store' | 'business' | 'source'

export interface CustomerFilters {
  visibilities: string[]
  maintainerUserIds: string[]
  storeIds: string[]
  businessTypes: string[]
  sources: string[]
}

export const emptyCustomerFilters = (): CustomerFilters => ({
  visibilities: [], maintainerUserIds: [], storeIds: [], businessTypes: [], sources: [],
})

export function serializeCustomerFilters(
  filters: CustomerFilters,
  options: { pageNo: number; pageSize: number; type: string; keyword: string; sort: string },
) {
  const params = new URLSearchParams({
    pageNo: String(options.pageNo),
    pageSize: String(options.pageSize),
    scope: 'ALL',
    sort: options.sort,
  })
  if (options.type) params.set('type', options.type)
  if (options.keyword) params.set('keyword', options.keyword)
  const appendMany = (key: string, values: string[]) => values.forEach((value) => params.append(key, value))
  appendMany('visibilities', filters.visibilities)
  appendMany('maintainerUserIds', filters.maintainerUserIds)
  appendMany('storeIds', filters.storeIds)
  appendMany('businessTypes', filters.businessTypes)
  appendMany('sources', filters.sources)
  return params
}

export function toggleCustomerFilterValue(values: string[], value: string) {
  return values.includes(value) ? values.filter((item) => item !== value) : [...values, value]
}

function shanghaiToday(now = new Date()) {
  return new Intl.DateTimeFormat('en-CA', {
    timeZone: 'Asia/Shanghai', year: 'numeric', month: '2-digit', day: '2-digit',
  }).format(now)
}

function monthDay(date: Date) {
  return `${String(date.getUTCMonth() + 1).padStart(2, '0')}-${String(date.getUTCDate()).padStart(2, '0')}`
}

export function customerBirthdayCue(birthday?: string, today = shanghaiToday()) {
  const birthdayMatch = birthday?.trim().match(/^(\d{1,2})-(\d{1,2})$/)
  const todayMatch = today.match(/^(\d{4})-(\d{2})-(\d{2})$/)
  if (!birthdayMatch || !todayMatch) return null
  const birthdayMonth = Number(birthdayMatch[1])
  const birthdayDay = Number(birthdayMatch[2])
  const validationDate = new Date(Date.UTC(2000, birthdayMonth - 1, birthdayDay))
  if (validationDate.getUTCMonth() + 1 !== birthdayMonth || validationDate.getUTCDate() !== birthdayDay) return null
  const normalizedBirthday = `${String(birthdayMonth).padStart(2, '0')}-${String(birthdayDay).padStart(2, '0')}`
  const start = new Date(Date.UTC(Number(todayMatch[1]), Number(todayMatch[2]) - 1, Number(todayMatch[3])))
  for (let days = 0; days < 7; days += 1) {
    const candidate = new Date(start)
    candidate.setUTCDate(candidate.getUTCDate() + days)
    if (monthDay(candidate) === normalizedBirthday) return days === 0 ? '今天生日' : `${days}天后`
  }
  return null
}
